import { graphConfig, loginRequest } from '../authConfig'
import { msalInstance } from '../index'

export async function callMsGraph () {
  const account = msalInstance.getActiveAccount()
  if (account == null) {
    throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.')
  }

  try {
    // Acquire token specifically for Microsoft Graph API
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account
    })

    const headers = new Headers()
    const bearer = `Bearer ${response.accessToken}`

    headers.append('Authorization', bearer)

    const options = {
      method: 'GET',
      headers
    }

    return await fetch(graphConfig.graphMeEndpoint, options)
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return await response.json()
      })
      .catch(error => {
        console.error('MS Graph API call error:', error)
        throw error
      })
  } catch (error) {
    console.error('Failed to acquire token for Microsoft Graph:', error)
    throw error
  }
}
